import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SysPesquisaDinamica } from 'src/app/model/system/sysPesquisaDinamica';
import { GenericService } from '../generics/generic.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: 'root'
})
export class SysEtiquetaService extends GenericService<SysPesquisaDinamica>{
    
    constructor(http: HttpClient) {
        super(http);
        super.initResource("syspesquisadinamica")
    }

}
